import React from 'react';
import {
    RadioGroup,
    FormControlLabel,
    Radio,
    Box,
    Stack,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';

// Tax Authority payment methods valid for a VAT payment report (v3).
const DIRECT_DEBIT = 1;
const CREDIT_CARD = 2;

const VatModalActions = ({
    t,
    direction,
    isRange,
    reportingWay,
    handleReportingWayChange,
    numberOfPayments,
    setNumberOfPayments,
    paymentMethod,
    setPaymentMethod,
    handleDownloadPdf,
    vatContentRef,
    setShowPCNModal,
    handleSaveVatReport,
    onClose,
    client
}) => {
    return (
        <div className="vat-modal-actions">
            <div className="vat-modal-actions__buttons">
                <Button
                    variant="contained"
                    onClick={() => handleDownloadPdf(vatContentRef)}
                    className="vat-modal-actions__btn vat-modal-actions__btn--primary"
                    sx={{
                        background: 'linear-gradient(135deg, #304FFF 0%, #5a73ff 100%)',
                        borderRadius: '8px',
                        px: 3,
                        py: 0.8,
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '13px',
                        boxShadow: '0 2px 8px rgba(48, 79, 255, 0.25)',
                        '&:hover': {
                            background: 'linear-gradient(135deg, #2a45e0 0%, #4d65f0 100%)',
                        }
                    }}
                >
                    {t('DownloadPDFFile')}
                </Button>

                <Button
                    variant="outlined"
                    onClick={() => setShowPCNModal(true)}
                    sx={{
                        borderColor: '#F9AA2A',
                        color: '#F9AA2A',
                        borderRadius: '8px',
                        px: 3,
                        py: 0.8,
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '13px',
                        '&:hover': {
                            borderColor: '#e09620',
                            backgroundColor: 'rgba(249, 170, 42, 0.06)',
                        }
                    }}
                >
                    {t('PCNFile')}
                </Button>
            </div>

            <div className="vat-modal-actions__reporting">
                <RadioGroup
                    row
                    value={reportingWay}
                    onChange={handleReportingWayChange}
                    className="vat-modal-actions__radio-group"
                >
                    <FormControlLabel
                        value="automatic"
                        control={<Radio size="small" sx={{ color: '#304FFF', '&.Mui-checked': { color: '#304FFF' } }} />}
                        label={<span className="vat-modal-actions__radio-label">{t('AutomaticTaxAuthorityReporting')}</span>}
                    />
                    <FormControlLabel
                        value="manual"
                        control={<Radio size="small" sx={{ color: '#304FFF', '&.Mui-checked': { color: '#304FFF' } }} />}
                        label={<span className="vat-modal-actions__radio-label">{t('ManualReporting')}</span>}
                    />
                    <FormControlLabel
                        value="unreported"
                        control={<Radio size="small" sx={{ color: '#304FFF', '&.Mui-checked': { color: '#304FFF' } }} />}
                        label={<span className="vat-modal-actions__radio-label">{t('Unreported')}</span>}
                    />
                </RadioGroup>

                {reportingWay === 'automatic' && (
                    <div className="vat-modal-actions__payment">
                        <div className="vat-modal-actions__payment-fields">
                            <FormControl sx={{ minWidth: 200 }} size="small">
                                <InputLabel sx={{ fontSize: '13px' }}>{t('PaymentMethod')}</InputLabel>
                                <Select
                                    value={paymentMethod}
                                    label={t('PaymentMethod')}
                                    onChange={(e) => setPaymentMethod(parseInt(e.target.value))}
                                    sx={{ borderRadius: '8px', fontSize: '13px' }}
                                >
                                    <MenuItem value={DIRECT_DEBIT}>{t('AccountChargeAuthorization')}</MenuItem>
                                    <MenuItem value={CREDIT_CARD}>{t('CreditCard')}</MenuItem>
                                </Select>
                            </FormControl>

                            <FormControl
                                sx={{ minWidth: 180 }}
                                size="small"
                                disabled={paymentMethod === CREDIT_CARD}
                            >
                                <InputLabel sx={{ fontSize: '13px' }}>
                                    {t('NumberOfPayments') || 'Number of Payments'}
                                </InputLabel>
                                <Select
                                    value={paymentMethod === CREDIT_CARD ? 1 : numberOfPayments}
                                    label={t('NumberOfPayments') || 'Number of Payments'}
                                    onChange={(e) => setNumberOfPayments(parseInt(e.target.value))}
                                    sx={{ borderRadius: '8px', fontSize: '13px' }}
                                >
                                    <MenuItem value={1}>{t('OnePayment') || '1'}</MenuItem>
                                    <MenuItem value={2}>{t('TwoPayments') || '2'}</MenuItem>
                                    <MenuItem value={3}>{t('ThreePayments') || '3'}</MenuItem>
                                    <MenuItem value={4}>{t('FourPayments') || '4'}</MenuItem>
                                </Select>
                            </FormControl>
                        </div>

                        <span className="vat-modal-actions__payment-hint">
                            {paymentMethod === CREDIT_CARD
                                ? t('CreditCardSinglePaymentHint')
                                : t('AccountChargeAuthorizationHint')}
                        </span>
                    </div>
                )}
            </div>

            <div className="vat-modal-actions__footer">
                {!isRange && (
                    <button className="vat-modal-actions__report-btn" onClick={handleSaveVatReport}>
                        {t('Report')}
                    </button>
                )}
                <button className="vat-modal-actions__close-btn" onClick={onClose}>
                    {t('close')}
                </button>
            </div>
        </div>
    );
};

export default VatModalActions;
